import { RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoint } from './constants';
import { ShareCaseArgs } from './types';

export const api = {
  getUsersForShareLink: async(caseId: number, query?:string) => {
    const response = await new RemoteData(endpoint.usersWithEmail({caseId, query})).resource<ApiResponse<any>>().filter({query}).all();
    return response.data;
  },
  shareDocument: async(args: ShareCaseArgs) => new RemoteData(endpoint.shareDocument(args)).resource<any>().create([{
    recipients: args.recipients,
    message: args.message,
    linkPath: args.linkPath
  }]),
  getUsersForShareLinkDraft: async(draftId: number, domainNoUsers: number, query?:string) => {
    const response = await new RemoteData(endpoint.usersWithEmailDraft({draftId, domainNoUsers, query}))
      .resource<ApiResponse<any>>().filter({query}).all();
    return response.data;
  }
};
